module.exports = __webpack_public_path__ + "static/img/6338_phase_function_Paper_Points.aeb90b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6338_phase_function_Paper_Points.png
// module id = EiZr
// module chunks = 0